import styled from '@emotion/styled';
import { Breakpoints, Colors, Typography } from 'goalsetter-webapp-components';
import { Image } from '@mantine/core';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 64px;
  width: 864px;
  margin-bottom: 70px;
  @media (max-width: ${Breakpoints.sm_portal}px) {
    width: 95%;
    padding-top: 16px;
    padding-bottom: 42px;
  }
`;

export const StyledTitle = styled.div`
  padding: 30px 0;
  width: 80%;
  color: ${Colors.WHITE};
  font-family: Avenir;
  font-size: 56px;
  font-style: normal;
  font-weight: 900;
  line-height: 72px;
  text-align: center;
  @media (max-width: ${Breakpoints.sm_portal}px) {
    font-size: 32px;
    font-weight: 800;
    line-height: 48px;
  }
`;

export const StyledImage = styled(Image)`
  padding-top: 24px;
  & .mantine-Image-image {
    border-radius: 12px;
  }
`;

export const StyledText = styled.div`
  ${Typography.GSCAPTION};
  font-weight: 400;
  color: ${Colors.BLUE_INVESTMENTS};
`;

export const RightCardWrapper = styled.div<{ isMobile?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  width: ${(props) => (props.isMobile ? '100%' : '35%')};
  height: ${(props) => (props.isMobile ? 'auto' : '100%')};
`;

export const RightCard = styled.div<{ isMobile?: boolean }>`
  position: ${(props) => (props.isMobile ? 'relative' : 'sticky')};
  top: 0;
  display: flex;
  flex-direction: column;
  background: ${Colors.WHITE};
  padding: 2rem;
  border-radius: 1rem;
  overflow: hidden;
`;

export const leftCardStyle = (isMobile?: boolean) => ({
  width: !isMobile ? '65%' : '100%',
});

export const registeredTrademarkStyle = {
  fontSize: '24px',
  verticalAlign: 'baseline',
};

export const validFormatLabelStyle = {
  fontWeight: '900',
};

export const mainCardsWrapperStyle = { gap: '16px', width: '100%' };

export const firstCheckboxGroupStyle = {
  gap: '10px',
  width: '100%',
  paddingTop: '10px',
};
export const secondCheckboxGroupStyle = { gap: '16px', paddingTop: '16px' };

export const goalsContainerStyle = { paddingTop: '16px' };

export const rowPaddingTop = { paddingTop: '16px' };

export const continueButtonStyle = { marginTop: '24px' };

export const textStyle = { fontWeight: 400 };

export const goalCardRegisteredTrademarkStyle = { fontSize: '12px' };
